<template>
  <v-footer id="footer" padless>
    <v-row class="ma-0" no-gutters style="width: 100%">
      <v-col>
        <v-card class="footer__background-color" width="100%" flat tile>
          <FooterContacts class="py-4 px-3" />
        </v-card>

        <v-divider />

        <v-row class="ma-0 my-3" justify="center" align="end">
          <span class="text-body-2 text--secondary">
            {{ $translate('POWERED_BY') }}
          </span>
          <a
            :href="accountInfo.AccountUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="mx-1"
          >
            <v-img
              :src="$store.getters['Account/accountInformation'].AccountLogo"
              max-width="110"
              max-height="50"
            />
          </a>
        </v-row>

        <v-row class="ma-0 mb-3" justify="center">
          <a
            class="mb-0 text-right subFooterLink primary--text"
            @click="goToPage('TermsAndConditions')"
          >
            {{ $translate('TERMS_AND_CONDITIONS') }}
          </a>

          <a
            class="mb-0 text-right subFooterLink primary--text"
            @click="goToPage('PrivacyStatement')"
          >
            {{ $translate('REGISTER_PRIVACY_STATEMENT') }}
          </a>
        </v-row>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import uiHelpers from '@/shared/ui_helpers';
import FooterContacts from '@/components/generalComponents/footer/FooterContacts';

export default {
  name: 'Footer',
  mixins: [uiHelpers],
  components: {
    FooterContacts,
  },
  computed: {
    accountInfo() {
      const info = this.$store.getters['Account/accountInformation'];
      if (info == null) {
        return {};
      }
      return info;
    },
    pgInfo() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
  },
  watch: {
    pgInfo() {
      this.updateBackgroundColor();
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.updateBackgroundColor();
  },
  methods: {
    redirectToPartnerLogin() {
      window.EventBus.fire('triggerOpenAccountFromMenu', {
        toggle: true,
        component: 'RedirectToPartner',
      });
    },
    updateBackgroundColor() {
      if (
        this.pgInfo != null &&
        this.pgInfo.PrimaryColor != null &&
        this.pgInfo.PrimaryColor.trim() !== ''
      ) {
        const el = document.querySelector('.footer__background-color');
        if (el != null) {
          // Use primary for background color
          el.style.backgroundColor = `${this.pgInfo.PrimaryColor}`;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.subFooter {
  font-size: 14px;
  font-weight: 400;
}
.subFooterLink {
  cursor: pointer;
  font-size: 14px;
  font-weight: 300;
  padding: 0px 12px;

  &:not(:last-of-type) {
    border-right: 1px solid #9e9e9e;
  }
}
a {
  text-decoration: inherit;
  color: inherit;
  cursor: auto;
}
</style>
